import type { AttendeeCacheData } from '../schema/AttendeeCacheData';
import type { FreeBusySessionData } from '../schema/FreeBusySessionData';
import { createStore } from 'owa-satcheljs';

interface FreeBusyCacheStore {
    sessionMap: Map<string, FreeBusySessionData>;
    attendeeMap: Map<string, AttendeeCacheData>;
}

const initialFreeBusyCacheStore: FreeBusyCacheStore = {
    sessionMap: new Map(),
    attendeeMap: new Map(),
};

export const getFreeBusyCacheStore: () => FreeBusyCacheStore = createStore<FreeBusyCacheStore>(
    'freeBusyCacheStore',
    initialFreeBusyCacheStore
);
